module.exports = __webpack_public_path__ + "static/media/press-freedom-index.b7caec17.jpg";